"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var load_more_1 = require("../features/load-more");
var multi_select_actions_1 = require("../features/multi-select-actions");
function init() {
    var container = document.getElementById('laboratory-results-container');
    if (container) {
        var settings = {
            // parameter
            /*date_from: (Math.trunc(Date.now() / 1000)) - 28 * seconds_in_a_day,
            date_to:(Math.trunc(Date.now() / 1000)) - 28 * seconds_in_a_day,*/
            date_from: 0,
            date_to: 0,
            page: 1,
            per_page: 20,
            sort_by: "probe_send_at",
        };
        var loadMore = (container.dataset.loadMore !== "false");
        if (window.location.pathname === '/dashboard') {
            settings.read = false;
            // on dashboard hide the items that were just read
            document.addEventListener('lgm.attachment.opened', function (event) {
                var _a;
                if (!(event instanceof CustomEvent))
                    return;
                if (!(event.target instanceof HTMLElement))
                    return;
                var row = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('[data-attachment-container="true"]');
                if (!!row)
                    row.remove();
                (0, multi_select_actions_1.rescanMultiSelectActionElements)();
            });
        }
        // anywhere hide the items that have been archived
        document.addEventListener('lgm.laboratory-result.archived', function (event) {
            var _a;
            if (!(event instanceof CustomEvent))
                return;
            if (!(event.target instanceof HTMLElement))
                return;
            var row = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('.laboratory-result-index-item');
            if (!!row)
                row.remove();
            (0, multi_select_actions_1.rescanMultiSelectActionElements)();
        });
        (0, load_more_1.initialize_load_more)('laboratory-results', settings).catch(function (e) { return console.error(e); });
    }
}
exports.init = init;
